import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReceiptAlertDialog } from './receipt-alert.page';

const routes: Routes = [
  {
    path: '',
    component: ReceiptAlertDialog
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReceiptAlertPageRoutingModule {}
